import { render, staticRenderFns } from "./gift-cards.component.vue?vue&type=template&id=5d227b34&"
import script from "./gift-cards.component.vue?vue&type=script&lang=js&"
export * from "./gift-cards.component.vue?vue&type=script&lang=js&"
import style0 from "./gift-cards.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ksaffer/Projects/Client/natorp-plant-database/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d227b34')) {
      api.createRecord('5d227b34', component.options)
    } else {
      api.reload('5d227b34', component.options)
    }
    module.hot.accept("./gift-cards.component.vue?vue&type=template&id=5d227b34&", function () {
      api.rerender('5d227b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "_src/js/components/gift-cards.component.vue"
export default component.exports